import StarRating from 'star-rating.js';
window.StarRating = StarRating;
//import * as Ladda from 'ladda';
//window.Ladda = Ladda;